import { Create, SimpleForm, ReferenceInput, AutocompleteInput, ArrayInput, SimpleFormIterator, required } from "react-admin";
import { Grid } from "@mui/material";
import BackButtonToolbar from "features/BackButtonToolbar";
import SpecializationRow from "./Partials/SpecializationRow";
import { administrationRequests } from "api/administrationApi";

const CreateTrainingBuildings = () => {
  return (
    <Create
      title="Създаване на учебна база"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <ReferenceInput
              source="buildingId"
              reference={administrationRequests.getBuildingsSelect()}
            >
              <AutocompleteInput
                label="Учебна база"
                optionText="name"
                optionValue="id"
                fullWidth
                validate={[required()]}
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              />
            </ReferenceInput>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <ArrayInput
              source="specializations"
              label="Специалности"
              validate={[required()]}
              defaultValue={[{}]}
            >
              <SimpleFormIterator inline>
                <SpecializationRow />
              </SimpleFormIterator>
            </ArrayInput>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export default CreateTrainingBuildings;
